import {ORIGINATIONS_APP_BASE_URL} from '../constants/global';
import { authenticatedFetch } from '@forwardfinancing/component-library';
import {fetchParams} from '../constants/fetchParams';

export function getMerchants(keyword) {
  const underwritingBaseURL = ORIGINATIONS_APP_BASE_URL();
  //Make sure to update api call with underwrting before production
  return authenticatedFetch(underwritingBaseURL + `merchant?text=${keyword}`, fetchParams())
    .then(response => response.json());
}
